import {Nullish} from 'shared/web';

import {LightboxAction} from './LightboxAction';

export interface LightboxImage {
  id: string;
  url: string;
  resizeUrl?: string;
  title?: string;
  fileName?: string;
  meta?: string | Nullish;
  actions?: LightboxAction[] | Nullish;
}
